var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-wrapper',{attrs:{"is-center-content":""}},[_c('be-placeholder-content',{attrs:{"icon":_vm.NotFound,"title":_vm.$t('b2c_page_not_found')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }